import { KtsVerificationComponent } from '../verification/verification.component';
import { KtsMultiSelectComponent } from '../multiselect/multiselect.component';
import { KtsMultiSelectPartnerCompanyComponent } from '../multiselect/multiselect-partner-company.component';
import { KtsMultiSelectPartnerUserComponent } from '../multiselect/multiselect-partner-user.component';
import { KtsMultiSelectConstructionWorkerComponent } from '../multiselect/multiselect-construction-worker.component';
import { KtsTaskComponent } from '../task/task.component';
import { KtsConstructionTaskComponent } from '../task/construction-task.component';
import { KtsGeneralTaskComponent } from '../task/general-task.component';
import { KtsImportTargetComponent } from '../import/import-target.component';
import { KtsProgressComponent } from '../progress/progress.component';
import { KtsReportComponent } from '../report/report.component';
import { KtsSearchComponent } from '../list/search.component';
import { KtsOutlineComponent } from '../outline/outline.component';
import { KtsConstructionOutlineComponent } from '../outline/construction-outline.component';
import { KtsSupervisorAddRowComponent } from '../supervisor/supervisor-addrow.component';
import { KtsSupervisorComponent } from '../supervisor/supervisor.component';
import { KtsConstructionMaterialComponent } from '../task/construction-material.component';
import { KtsGeneralConstructionMaterialComponent } from '../task/general-construction-material.component';
import { KtsGanttComponent } from '../gantt/gantt.component';
import { KtsGeneralGanttComponent } from '../gantt/general-gantt.component';
import { KtsReportDownloadComponent } from '../report/report-download.component';
import { KtsInformationClaimStatusSelectComponent } from '../information/information-claim-status-select.component';
import { KtsReceptionContentComponent } from '../reception/reception-content.component';
import { KtsConstructionTypeComponent } from '../constructiontype/construction-type.component';
import { KtsPartnerAreaComponent } from '../partner/partner-area.component';
import { KtsMapComponent } from '../map/map.component';
import { KtsMultiUploadComponent } from '../upload/multi-upload.component';
import { KtsMaintenanceReceptionTimeComponent } from '../maintenance/maintenance-reception-time.component';
export var ktsComponents = {
    KtsVerificationComponent: KtsVerificationComponent,
    KtsMultiSelectComponent: KtsMultiSelectComponent,
    KtsMultiSelectPartnerCompanyComponent: KtsMultiSelectPartnerCompanyComponent,
    KtsMultiSelectPartnerUserComponent: KtsMultiSelectPartnerUserComponent,
    KtsMultiSelectConstructionWorkerComponent: KtsMultiSelectConstructionWorkerComponent,
    KtsTaskComponent: KtsTaskComponent,
    KtsConstructionTaskComponent: KtsConstructionTaskComponent,
    KtsGeneralTaskComponent: KtsGeneralTaskComponent,
    KtsImportTargetComponent: KtsImportTargetComponent,
    KtsProgressComponent: KtsProgressComponent,
    KtsReportComponent: KtsReportComponent,
    SearchComponent: KtsSearchComponent,
    KtsOutlineComponent: KtsOutlineComponent,
    KtsConstructionOutlineComponent: KtsConstructionOutlineComponent,
    KtsSupervisorAddRowComponent: KtsSupervisorAddRowComponent,
    KtsSupervisorComponent: KtsSupervisorComponent,
    KtsConstructionMaterialComponent: KtsConstructionMaterialComponent,
    KtsGeneralConstructionMaterialComponent: KtsGeneralConstructionMaterialComponent,
    KtsGanttComponent: KtsGanttComponent,
    KtsGeneralGanttComponent: KtsGeneralGanttComponent,
    KtsReportDownloadComponent: KtsReportDownloadComponent,
    KtsInformationClaimStatusSelectComponent: KtsInformationClaimStatusSelectComponent,
    KtsReceptionContentComponent: KtsReceptionContentComponent,
    KtsConstructionTypeComponent: KtsConstructionTypeComponent,
    KtsPartnerAreaComponent: KtsPartnerAreaComponent,
    KtsMapComponent: KtsMapComponent,
    KtsMultiUploadComponent: KtsMultiUploadComponent,
    KtsMaintenanceReceptionTimeComponent: KtsMaintenanceReceptionTimeComponent,
};
//# sourceMappingURL=content.component.js.map